import React, { useEffect, useState } from 'react';
import { getCompanyList, getDepartmentList, getSubDepartmentList, getDesignationList, getManagerList, addEmployee, uploadEmployeeFile } from './superAdminSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { Submitbtn } from '../../Component';
import { InputField } from '../../Component';
import DropDown from '../../Component/dropdown';
import LabelInput from '../../Component/labelInput';
import PageTitle from '../../module/pageTitle';
import AdminTable from '../../Component/adminTable';
const PayRoll = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [year, setYear] = useState<any>();
    const [startMonth, setStartMonth] = useState<any>();
    const [endMonth, setEndMonth] = useState<any>();
    const [companyList, setCompanyList] = useState<any>([]);
    const [companyName, setCompanyName] = useState<any>();
    const [departmentList, setDepartmentList] = useState<any>([]);
    const [departmentName, setDepartmentName] = useState<any>([]);
    const [subDepartmentList, setSubDepartmentList] = useState<any>();
    const [subDepartmentName, setSubDepartmentName] = useState<any>();
    const months = [{ name: "January" }, { name: "Feburary" }, { name: "March" }, { name: "April" }, { name: "May" }, { name: "June" }, { name: "July" }, { name: "Augast" }, { name: "September" }, { name: "November" }, { name: "December" }];

    useEffect(() => {
        dispatch(
            getCompanyList({
                callback: (res: any) => {
                    setCompanyList(res?.data);
                },
                errorCallback: () => { },
            })
        );
    }, []);

    const onChangeMonth = (val: any, key: string) => {
        if (key === "startMonth") {
            setStartMonth(val);
        } else if (key === "endMonth") {
            setEndMonth(val);
        }
    };

    const onChangeEmploymentDetails = (val: any, key: string) => {
        if (key === 'company') {
            setCompanyName(val);
            dispatch(
                getDepartmentList({
                    callback: (res: any) => {
                        setDepartmentList(res?.data);
                    },
                    errorCallback: () => { },
                })
            );
        } else if (key === 'department') {
            console.log("val", val);
            setDepartmentName(val);
            dispatch(getSubDepartmentList({
                id: val?._id,
                callback: (res: any) => {
                    setSubDepartmentList(res?.data);
                },
                errorCallback: () => { }
            }));
        }
        else if (key === 'subDept') setSubDepartmentName(val);
    };
    const renderSearch = () => {
        return (
            <form>
                <div className="row align-items-center">
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Year"} />
                        <InputField
                            key={"ex2"}
                            placeholder={"Enter Year"}
                            setInputText={(value: any) => (setYear(value))
                            }
                            value={year}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Start Month"} />
                        <DropDown
                            labelName={"Select Start Month"}
                            setInputText={(value: any) => onChangeMonth(value, "startMonth")}
                            options={months}
                            value={startMonth}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"End Month"} />
                        <DropDown
                            labelName={"Select End Month"}
                            setInputText={(value: any) => onChangeMonth(value, 'endMonth')}
                            options={months}
                            value={endMonth}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Company"} />
                        <DropDown
                            labelName="Select Company"
                            setInputText={(value: any) => onChangeEmploymentDetails(value, "company")}
                            value={companyName}
                            options={companyList}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Department"} />
                        <DropDown
                            labelName="Select Department"
                            setInputText={(value: any) => onChangeEmploymentDetails(value, "department")}
                            options={departmentList}
                            value={departmentName?.name}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Sub Department"} />
                        <DropDown
                            labelName="Select Sub Department"
                            setInputText={(value: any) => onChangeEmploymentDetails(value, "subDept")}
                            value={subDepartmentName}
                            options={subDepartmentList}
                        // Isrequired={true}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Mapping"} />
                        <DropDown
                            labelName={"Select Mapping"}
                            setInputText={(value: any) => ('')}
                            options={''}
                            value={''}
                        />
                    </div>
                    <div className='col-md-1'>
                        <Submitbtn name={"Search"} disabled={false} />
                    </div>
                </div>
            </form >
        )
    };
    const renderTable = () => {
        return (
            <>
                <div className='bxshadow p-2 borderRadius mb-3'>
                    <h2 className='Title colorBlack font24 mb-0 me-2'>Total Amount: 1000000</h2>
                </div>

                <div className='bxshadow p-2 borderRadius'>
                    <div className="admin-table table-responsive-md table-responsive">
                        <table className="table table-striped table-hover align-middle text-md-start text-center">
                            <thead className=''>
                                <tr>
                                    <th className='font18 fw-bold'>SOFTWARE DEVELOPMENT</th>
                                    <th className='font18 fw-bold text-end'>100000</th>
                                </tr>
                                <tr>
                                    <th className='font16 fw-bold'>PRODUCT MANAGER</th>
                                    <th className='font18 fw-bold text-end'>100000</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr></tr>
                                <tr>
                                    <td>DHARMVEER SHARMA</td>
                                    <td className='text-end'>100000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Pay Roll"}
                    breadCrumb={""}
                    isEditMode={''}
                    cancelEdit={(value: any) => ('')} />
            </div>
            <div className='formDiv'>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    {renderSearch()}
                </div>
                {renderTable()}
            </div>
        </div>
    );
}

export default PayRoll;